import { Title } from '@components/atoms/Title';
import { Button, Footer } from '@components/atoms';
import { useNavigate } from 'react-router-dom';
import { useNewUser } from './useSelectAccount';

export function SelectAccount() {
  const navigate = useNavigate();
  const { availableRoles, selectedRole, setSelectedRole, handleAddAccount } = useNewUser();

  return (
    <div className="p-4">
      <Title title="• Adicionar conta" subtitle="Selecione o tipo de conta que deseja criar" />

      <div className="flex flex-col mt-6 gap-4 max-h-[calc(100vh-200px)] overflow-y-auto mb-40">

        {availableRoles && availableRoles.map((role) => (
          <div
            key={role}
            onClick={() => setSelectedRole(role)}
            className={`flex items-center gap-3 p-5 border border-b border-gray-200 rounded ${selectedRole === role ? 'bg-indigo-200 border border-indigo-500 rounded' : ''} cursor-pointer `}
          >
            <input
              type="radio"
              id={role}
              checked={selectedRole === role}
              onChange={() => setSelectedRole(role)}
            />
            <label htmlFor={role} className="text-gray-700 font-medium">
              {role === 'titular_da_nf' ? 'Titular da NF' : role.charAt(0).toUpperCase() + role.slice(1)}
            </label>
          </div>
        ))
        }
      </div>

      <div className="fixed bottom-0 left-0 w-full bg-white p-4">
        <Footer>
          <div className="flex flex-col gap-3">
            <Button isStretched isPrimary onClick={handleAddAccount} disabled={!selectedRole}>
              Prosseguir
            </Button>
            <Button isStretched onClick={() => navigate(-1)}>
              Cancelar
            </Button>
          </div>
        </Footer>
      </div>
    </div>
  );
}
